import { loadableWithFallback } from '@vision/ui/utils';
import type { TableChart2Props } from './TableChart2';

export const TableChart2 = loadableWithFallback<TableChart2Props>(() => import('./TableChart2'));
